
define("rv!templates/partials/breadcrumbs",[],function(){return { v:3,
  t:[ { t:7,
      e:"ul",
      a:{ "class":"breadcrumb",
        style:"margin-top: -10px; border-top: none;" },
      f:[ { t:4,
          f:[ { t:7,
              e:"li",
              f:[ { t:4,
                  f:[ " > " ],
                  n:50,
                  x:{ r:[ "@index" ],
                    s:"_0>0" } },
                " ",
                { t:4,
                  f:[ { t:7,
                      e:"a",
                      a:{ href:[ { t:2,
                            r:"url" } ] },
                      f:[ { t:2,
                          r:"name" } ] } ],
                  n:50,
                  x:{ r:[ "url" ],
                    s:"_0!=null" } },
                { t:4,
                  n:51,
                  f:[ { t:2,
                      r:"name" } ],
                  x:{ r:[ "url" ],
                    s:"_0!=null" } } ] } ],
          n:52,
          r:"breadcrumbs" } ] } ] };});
